// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"127395c888a1dc9e","581":"323d23ad410628de","768":"02275ff5a3444b93"}[chunkId] + ".js";
};